import { BatterySearchResult } from '@/types';
import { formatCurrency } from './formatters';

export const generateCustomerMessage = (battery: BatterySearchResult): string => {
  const { brand, size, priceRetail, priceWholesale, totalStock } = battery;
  
  const availability = totalStock > 0 ? 'متوفر' : 'غير متوفر';
  
  let message = `🔋 *${brand} - ${size}*\n\n`;
  message += `📦 الحالة: ${availability}\n`;
  
  if (totalStock > 0) {
    message += `💰 السعر للقطعة: ${formatCurrency(priceRetail)}\n`;
    message += `💵 سعر الجملة: ${formatCurrency(priceWholesale)}\n`;
    message += `📊 الكمية المتاحة: ${totalStock} قطعة\n`;
  } else {
    message += `\n⚠️ عذراً، هذا المنتج غير متوفر حالياً\n`;
  }
  
  message += `\n✨ للطلب أو الاستفسار، تواصل معنا الآن!`;
  
  return message;
};

export const generateLowStockAlert = (brand: string, size: string, quantity: number): string => {
  return `⚠️ تنبيه: مخزون منخفض!\n\n🔋 ${brand} - ${size}\n📦 الكمية المتبقية: ${quantity} قطعة\n\nيرجى إعادة التوريد في أقرب وقت.`;
};

export const generateStockReport = (batteries: BatterySearchResult[]): string => {
  let report = `📊 *تقرير المخزون*\n`;
  report += `التاريخ: ${new Date().toLocaleDateString('ar-EG')}\n\n`;
  
  batteries.forEach((battery, index) => {
    report += `${index + 1}. ${battery.brand} - ${battery.size}\n`;
    report += `   المخزون: ${battery.totalStock} قطعة\n`;
    report += `   السعر: ${formatCurrency(battery.priceRetail)}\n\n`;
  });
  
  return report;
};